import { render, staticRenderFns } from "./RealtimeApp.vue?vue&type=template&id=c0b24638&scoped=true"
import script from "./RealtimeApp.vue?vue&type=script&lang=js"
export * from "./RealtimeApp.vue?vue&type=script&lang=js"
import style0 from "./RealtimeApp.vue?vue&type=style&index=0&id=c0b24638&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b24638",
  null
  
)

export default component.exports